// Email service for sending order details
export const sendOrderEmail = async (orderDetails) => {
  try {
    // Using EmailJS service for client-side email sending
    // You'll need to set up EmailJS account and get service ID, template ID, and user ID

    // For now, we'll use a simple approach with mailto link
    // In production, you should use a proper email service like EmailJS, SendGrid, or a backend API

    const subject = encodeURIComponent(
      `New Print Order - ${orderDetails.customerName || "Customer"}`,
    );

    const body = encodeURIComponent(`
Order Details:

Customer Information:
- Name: ${orderDetails.customerName || "Not provided"}
- Phone: ${orderDetails.customerPhone || "Not provided"}
- Address: ${orderDetails.address || "Not provided"}
- Distance: ${
      orderDetails.distance ? `${orderDetails.distance} km` : "Not provided"
    }

Order Information:
- Documents: ${orderDetails.documentsCount} file(s)
- Total Pages: ${orderDetails.totalPages}
- Print Type: ${orderDetails.color ? "Color" : "Black & White"}
- Print Cost: ₹${orderDetails.printCost}
- Delivery Cost: ${
      orderDetails.deliveryCost > 0 ? `₹${orderDetails.deliveryCost}` : "Free"
    }
- Total Cost: ₹${orderDetails.totalCost}

Delivery Notes: ${orderDetails.deliveryNotes || "None"}

Order Time: ${new Date().toLocaleString()}
    `);

    // Create mailto link
    const mailtoLink = `mailto:admin@printmypapers.com?subject=${subject}&body=${body}`;

    // Open default email client
    window.open(mailtoLink);

    return { success: true, message: "Email client opened successfully" };
  } catch (error) {
    console.error("Error sending email:", error);
    return { success: false, message: "Failed to send email" };
  }
};

// Alternative: Using EmailJS (requires setup)
export const sendOrderEmailWithEmailJS = async (orderDetails) => {
  // Placeholder implementation for EmailJS integration.
  // When ready, implement using the EmailJS SDK and return success/failure accordingly.
  // Example (to implement later):
  // const templateParams = { /* ... */ };
  // await emailjs.send('SERVICE_ID', 'TEMPLATE_ID', templateParams, 'USER_ID');

  return { success: true, message: "EmailJS not configured yet" };
};
